var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"card--shadow"},[_c('pa-list',{attrs:{"pas":_vm.pas}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }